import * as React from 'react';

import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';

import Bs4Kartoteka from '../Bs4Kartoteka'
import Bs4MainDispatch from '../Bs4MainDispatch';
import Bs4ReportViewIcon from './Bs4ReportViewIcon'
import { v4 as uuidv4 } from 'uuid';
import { EventEmit, isNullOrNaN } from '../Bs4Components/Bs4Utils'
import { Typography } from '@mui/material';
import Bs4I18N from '../Bs4I18N';
import { shallowEqual } from '../Bs4Components/Bs4Utils';


export default class Bs4DataProvider {
  static ROW_EDITED = 'row_edited';
  static DATA_LOADED = 'data_loaded';
  static PAGE_CHANGED = 'page_changed';

  constructor(props, packColumnLayout, daneName) {
    this.props = props;
    this.daneName = daneName || 'dane';
    this.bs4KartotekaId = props.bs4KartotekaId;
    this.optionId = props.optionId;
    this.formId = props.formId || null;
    this.eventEmit = new EventEmit();
    this.packColumnLayout = packColumnLayout || (() => {
      //console.log('=== packColumnLayout: not applicable ===')
      return JSON.stringify([]);
    })
  }

  on(name, onFunction) {
    this.eventEmit.on(name, onFunction);  
  }

  off(onFunction) {
    this.eventEmit.off(onFunction);  
  }

  trigger(name, ...params) {
    this.eventEmit?.trigger(name, ...params)    
  }

  resetBs4PageProps() {
    this.bs4PageProps = {
      counter: 0,
      currentPage: 0,
      paglim: 50,
      lastRow: 0,
      lastRowOnPage: {page:0, rows:0},
      lastPage: 0,
      inProgress: true,
      pages: {},
      previousRows: 0, 
      currentRows: 0,

      addRowsForPage: function(page, value) {
        this.pages[page] = value;
      },

      getRowsForPage: function(page) {
        const entries = Object.entries(this.pages).sort(([key1, value1], [key2, value2]) => key1 - key2);
        let lastPage = 0;
        let previousRows = 0;
        for (const [key, currentRows] of entries) {
          const currentPage = parseInt(key)
          if (lastPage !== currentPage) {
            console.log('... FETCH_MORE JSON Error...lastPage !== key', lastPage, currentPage, currentRows); 
            return [null, null];
          }          
          if (page === currentPage) return [previousRows, currentRows];
          previousRows += currentRows;
          lastPage += 1;
        }
      },
  
      getStart: function()  {
        return this.currentPage * this.paglim;
      },
    };
    return this.bs4PageProps;
  }

  defaultCriteriaVals() {
    const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
    const bs4Option = bs4Kartoteka.getBs4Option(this.optionId);
    return {
      currCardViewId: this.bs4KartotekaId,
      optionId: this.optionId,
      currFormId: this.formId,
      parametrJs: JSON.stringify(bs4Option.bs4Form.gatherCriteriaValues()),
    }
  }

  fetchCriteriaVals() {				
		const filterCriteria = this.defaultCriteriaVals();    				
		if (this.remembersettings) filterCriteria.remembersettings = 1; //pamiętaj układ
		filterCriteria.newGridDesign = this.packColumnLayout();	// zapamietany uklad kolumn
		return filterCriteria;
	}

  getDebugInfo = () => {
    return this.bs4KartotekaId+', '+this.optionId+', '+(this.formId || '?')
  }

  getPageParam(param) {
    return Bs4Kartoteka.get(this.bs4KartotekaId)?.message?._Komunikat?.pageParams[this.optionId]?.[param];
	}

  getColDef() {   
    return Bs4Kartoteka.get(this.bs4KartotekaId)?.message?._Komunikat?.col_def[this.optionId] ||  [];
  }  
  
  getData() {
    console.log('== Error === Bs4GenericReport == getData - not implemented')
    return []
  }

  clearAllCriteria() {
    const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
    const bs4Option = bs4Kartoteka.getBs4Option(this.optionId);
    bs4Option.bs4Form.clear();
  }

  handleReportIconShow = (e) => {
    // console.log('.........ReportIconShow.....')
    this.remembersettings = false;
    this.fetchMore();
  }

  handleReportIconRemember = (e) => {
    // console.log('.........ReportIconRemember.....')
    this.remembersettings = true;
    this.fetchMore();
  }

  handleReportIconReset = (e) => {
    // console.log('.........ReportIconReset.....')
    this.remembersettings = false;
    Bs4MainDispatch.commandParser('Bs4PrefsReset', { 
      js_ForgetOptionId: this.optionId, 
      currFormId: this.formId,
    }, this.bs4KartotekaId);    
    this.clearAllCriteria();
    this.fetchMore();
  }

  fetchMore() {
    const baseValues = this.fetchCriteriaVals();
    if (!this.bs4PageProps) this.resetBs4PageProps();
    baseValues.page = this.bs4PageProps.currentPage;
    baseValues.start = this.bs4PageProps.getStart();
    if (this.remembersettings) baseValues.remembersettings = 1;    
    const newBaseValues = Bs4MainDispatch.getParserParams(baseValues, this.bs4KartotekaId);

    const formData = new FormData();
    for (let [key, value] of Object.entries(newBaseValues)) formData.append(key, value);
    fetch(Bs4MainDispatch.getUrlPath('web.php?com=Bs4ReportData'), {method: 'POST', body: formData})
    .then(response => response.text())
    .then(returnedText => {
      try {
        Bs4MainDispatch.speedRun((tag) => {      
          console.log(Bs4MainDispatch.speedNextTime(tag), Bs4MainDispatch.speedBs4KarOpt(this.bs4KartotekaId, this.optionId));
        }, 'DataProvider.More');

        const returnedJson = JSON.parse(returnedText);
        Bs4MainDispatch.parsingBs4Response(returnedJson, this.bs4KartotekaId);
        if (!Array.isArray(returnedJson[this.daneName])) {
          console.log('... FETCH_MORE Error ...', returnedText);
          returnedJson[this.daneName] = [];
        }

        const data = returnedJson[this.daneName].map((record, index) => {
          record._key = index;          
          return record;
        })      

        const ilosc = returnedJson.ilosc || data.length || 0;

        if (returnedJson.nextPage === 'on') {
          if (this.bs4PageProps.currentPage === this.bs4PageProps.lastPage) {
            this.bs4PageProps.lastPage += 1;
            if (this.bs4PageProps.lastRowOnPage.page === this.bs4PageProps.currentPage) {
              this.bs4PageProps.lastRow -= this.bs4PageProps.lastRowOnPage.rows;
            }
            this.bs4PageProps.lastRow += ilosc;
            //this.bs4PageProps.lastRow += data.length;
          }
        } else if (returnedJson.nextPage === 'off') {
          if (this.bs4PageProps.currentPage === this.bs4PageProps.lastPage) {
            if (this.bs4PageProps.lastRowOnPage.page === this.bs4PageProps.currentPage) {
              this.bs4PageProps.lastRow -= this.bs4PageProps.lastRowOnPage.rows;
            }            
            this.bs4PageProps.lastRow += ilosc;
            this.bs4PageProps.lastRowOnPage.page = this.bs4PageProps.currentPage;
            this.bs4PageProps.lastRowOnPage.rows = ilosc;
          }
        } else {
          this.bs4PageProps.currentPage = baseValues.page;
          this.bs4PageProps.lastRow = ilosc;
          this.bs4PageProps.lastPage = Math.ceil(ilosc / this.bs4PageProps.paglim);
        }

        this.bs4PageProps.counter += 1;
        this.bs4PageProps.inProgress = false;

        this.bs4PageProps.addRowsForPage(baseValues.page, ilosc);
        [this.bs4PageProps.previousRows, this.bs4PageProps.currentRows] = this.bs4PageProps.getRowsForPage(baseValues.page);                

        // console.log('... FETCH_MORE JSON ...', baseValues, returnedJson, this.bs4PageProps, previousRows, currentRows);

        this.trigger(Bs4DataProvider.DATA_LOADED, data);
        this.trigger(Bs4DataProvider.PAGE_CHANGED, {...this.bs4PageProps});

      } catch (error) {
        console.log(returnedText);
        console.log(error);
      }            
    })
    .catch((error) => {
      console.log(error);
    });
  }

  ViewRowsShown =(props) => {        
    const toRow   = Math.min(this.bs4PageProps.lastRow, (this.bs4PageProps.currentPage + 1) * this.bs4PageProps.paglim);
    const ofRows  = this.bs4PageProps.lastRow;
    const counter = this.bs4PageProps.counter;
    const fromRow = Math.min(this.bs4PageProps.currentPage * this.bs4PageProps.paglim + 1, toRow);
    const [displayed, noDataToDisplay, pleaseWait] = Bs4I18N.useTTA([
      ["%s - %s of %s displayed", 'Wyświetlono %s - %s z %s', this.constructor.name],
      ["No data to display", 'Brak danych do wyświetlenia', this.constructor.name],
      ["Please wait...", 'Proszę czekać...', this.constructor.name],
    ]);
    const text = React.useMemo(() => {
      let fromRowOk = fromRow;
      let toRowOk = toRow;
      
      if (!isNullOrNaN(this.bs4PageProps.previousRows) && !isNullOrNaN(this.bs4PageProps.currentRows)) {
        fromRowOk = this.bs4PageProps.previousRows + 1;
        toRowOk = this.bs4PageProps.previousRows + this.bs4PageProps.currentRows;
      }

      let text = displayed;
      text = text.replace('%s', fromRowOk);
      text = text.replace('%s', toRowOk);
      text = text.replace('%s', ofRows);
      if (this.bs4PageProps.inProgress) return pleaseWait;
      return ofRows ? text : noDataToDisplay;
    }, [fromRow, toRow, ofRows, counter, this.bs4PageProps.inProgress, this.bs4PageProps.previousRows, this.bs4PageProps.currentRows]);

    // console.log('...ViewRowsShown...', fromRow, ofRows, text, props, this.bs4PageProps);

    return <Typography variant='body2'>{text}</Typography>   
  }

  ViewPagination = (props) => {
    const report = this;
    
    const [lastRow, setLastRow] = React.useState(this.bs4PageProps?.lastRow || 0);
    const [lastPage, setLastPage] = React.useState(this.bs4PageProps?.lastPage || 0);
    const [currentPage, setCurrentPage] = React.useState(this.bs4PageProps?.currentPage || 0);
    

    const handleChange = React.useCallback((event, page) => {      
      this.bs4PageProps.currentPage = page - 1;
      this.fetchMore();
    }, []);

    React.useEffect(() => {      
      const setBs4PageProps = (bs4PageProps) => {
        // console.log('... setBs4PageProps ...', bs4PageProps);
        setLastRow(bs4PageProps.lastRow);
        setLastPage(bs4PageProps.lastPage);
        setCurrentPage(bs4PageProps.currentPage);
      }

      this.on(Bs4DataProvider.PAGE_CHANGED, setBs4PageProps);

      return(() => this.off(setBs4PageProps));
    }, [setLastPage, setCurrentPage])

    // console.log('... viewPagination ...', this.bs4PageProps);
    const refSpeedTest = React.useRef({
      shallowEqualValues: null,
      shallowEqualProps: null,
    });    
    
    Bs4MainDispatch.speedRun((tag) => {
      const newObj = {  
        lastRow,
        lastPage,
        currentPage,
      };
      const sv = shallowEqual(newObj, refSpeedTest.current.shallowEqualValues, Bs4MainDispatch.speedPrefix+tag+' EqualValues');
      const sp = shallowEqual(props, refSpeedTest.current.shallowEqualProps, Bs4MainDispatch.speedPrefix+tag+' EqualProps');
      console.log(Bs4MainDispatch.speedNextTime(tag), Bs4MainDispatch.speedBs4KarOpt(this.bs4KartotekaId, this.optionId), Boolean(this.props.criterion) ? 'CR' : this.props?.formId , sv, sp,);
      refSpeedTest.current.shallowEqualValues = newObj;
      refSpeedTest.current.shallowEqualProps = props;
    }, 'DataProvider');    

    return (
      <Stack 
        direction="row" 
        justifyContent="space-between" 
        alignItems="center" 
        spacing={1} 
        p={1}
      >
        <Pagination 
          count={lastPage + 1} 
          page={currentPage + 1} 
          onChange={handleChange}
          hidePrevButton hideNextButton
          //siblingCount={2}
          //variant='outlined'
        />
        {/* <report.ViewIcon flex={0}/> */}
        <report.ViewRowsShown 
          rows={lastRow}
          count={lastPage}
          page={currentPage} 
          onChange={handleChange}
        />                
        {props.viewIcon ?
          <Bs4ReportViewIcon 
            onShow={report.handleReportIconShow}
            onRemember={report.handleReportIconRemember}
            onReset={report.handleReportIconReset}
          />
        : null}
      </Stack>
    )
  }
}
